// (1) ALL ISO 3166 country codes:
// https://dev.maxmind.com/geoip/legacy/codes/iso3166/

// (2) EU countries:
// https://ec.europa.eu/eurostat/statistics-explained/index.php/Glossary:Country_codes
export default [
  // European Free Trade Association (EFTA)
  'IS', // Iceland
  'NO', // Norway
  'LI', // "Liechtenstein"'
  'CH', // "Switzerland"'
  // 'GB', // (2) list uses "UK"

  // EU countries
  'EU', // used when a specific country code has not been designated
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR', // Greece - EU list (2) uses "EL"
  'HR', // Croatia
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE'
]
